
import { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../axiosInterceptor";
const PermissionContext = createContext();
const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState({
    pages: [],
    actions: {}
  });

  const [accessToken, setAccessToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

 useEffect(() => {
  const fetchPermissions = async () => {
    if (!accessToken) return;
    try {
      const res = await axiosInstance.get("permission-allow");
      const data = res.data.data;
      const pages = data.map((p) => p.pageName?.toLowerCase());
      const actions = {};
      data.forEach((p) => {
        actions[p.pageName.toLowerCase()] = p.actions || [];
      });

      setPermissions({ pages, actions });
    } catch (err) {
      return err
    } finally {
      setLoading(false);
    }
  };

  fetchPermissions();
}, [accessToken]);

  return (
    <PermissionContext.Provider
      value={{ permissions, setAccessToken, loading }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext);

export default PermissionProvider;